import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { Observable } from 'rxjs';
import { DumbMemberListItem } from '../super-admin-member-management/DTOs/dumb-member-list-item';
import { SuperPaymentHistoryDTInfo } from './DTOs/super-payment-history-dtinfo';

@Injectable({
  providedIn: 'root'
})
export class PaymentHistoryService {
  readonly relativeBase = "super-admin-payment-management/";


  constructor(private http: ApiClient) {

  }

  getMembersForFilter(filterText): Observable<DumbMemberListItem[]> {
    return this.http.get(this.relativeBase + "for-invoice-filter?filterText=" + filterText);
  }
  searchPayments(request):Observable<SuperPaymentHistoryDTInfo>{
    return this.http.post(this.relativeBase + "search-payments", request);
  }
  searchPaymentsCsv(request):Observable<any>{
    return this.http.post(this.relativeBase + "search-payments/csv", request, false, null, 'text');
  }
}
